import { msg } from '@lingui/core/macro';
import { translateLazy } from '@utils/translations.ts';

export const SHARED_GLOBAL_ALERT_BANNER_TITLE = msg`Scheduled maintenance notice`;
export const SHARED_GLOBAL_ALERT_BANNER_MAINTENANCE_INTRO = msg`Our system will be`;
export const SHARED_GLOBAL_ALERT_BANNER_MAINTENANCE_OUTRO = msg`due to scheduled maintenance. We apologize for any inconvenience.`;
export const SHARED_GLOBAL_ALERT_BANNER_UNAVAILABLE_ON = msg`unavailable on`;
export const SHARED_GLOBAL_ALERT_BANNER_TO = msg`to`;

export const GLOBAL_ALERT_BANNER_TEXTS = {
    TITLE: translateLazy(SHARED_GLOBAL_ALERT_BANNER_TITLE),
    MAINTENANCE_INTRO: translateLazy(SHARED_GLOBAL_ALERT_BANNER_MAINTENANCE_INTRO),
    MAINTENANCE_OUTRO: translateLazy(SHARED_GLOBAL_ALERT_BANNER_MAINTENANCE_OUTRO),
    UNAVAILABLE_ON: translateLazy(SHARED_GLOBAL_ALERT_BANNER_UNAVAILABLE_ON),
    TO: translateLazy(SHARED_GLOBAL_ALERT_BANNER_TO),
};
